angular.module('elfium').filter('elfiumPreSave', ['elfiumSQLDateFilter', 
    function (elfiumSQLDateFilter) {
        return function (fieldTypesConstant, inputObject) {
            var outputObject = angular.copy(inputObject);
            angular.forEach(fieldTypesConstant.DATE, function (dateField) {
                outputObject[dateField] = elfiumSQLDateFilter(outputObject[dateField]);
            });
            return outputObject;
        };
    }
]);


// WEBPACK FOOTER //
// ./src/app/components/elfium/elfiumPreSaveFilter.ts